/**
 * Parsing for the Review party-identification inputs, where a user types one or
 * more entity names by hand.
 */

/** Splits a raw input into clean entity names: comma-separated, trimmed, de-duplicated. */
export function parseEntityInput(raw: string): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const part of (raw ?? '').split(',')) {
    const name = part.trim();
    if (!name || seen.has(name)) continue;
    seen.add(name);
    out.push(name);
  }
  return out;
}

/**
 * Existing selections plus whatever the user just typed.
 *
 * Returns the same array instance when nothing new was added, so callers can
 * skip a pointless state update — and, more importantly, so committing an empty
 * or fully-duplicate draft is a no-op rather than a spurious change.
 */
export function mergeEntityInput(existing: readonly string[], raw: string): string[] {
  const additions = parseEntityInput(raw).filter((name) => !existing.includes(name));
  if (additions.length === 0) return existing as string[];
  return [...existing, ...additions];
}
